export function scrollSpy() {

    const scrollspy = document.querySelector('.steps');
    let scrollspyItems = scrollspy.querySelectorAll('.steps__step');

    function setActiveScrollspyItem() {
        let currentIndex;
        scrollspyItems.forEach((scrollspyItem, index) => {
            if (scrollspyItem) {

                const animation = scrollspyItem.querySelector('.steps__animation');
                if (scrollspyItem.classList.contains('active')) {
                    if (animation) {
                        animation.play();
                    }
                } else {
                    if (animation) {
                        animation.pause();
                    }
                }

                const topOffset = scrollspyItem.getBoundingClientRect().top;
                const viewportHeight = window.innerHeight;
                if (topOffset < (viewportHeight / 2)) {
                    currentIndex = index;
                } else {
                    scrollspyItem.classList.remove('active');
                }
            }
        });
        if (currentIndex >= 0) {
            scrollspyItems[currentIndex].classList.add('active');

            if (currentIndex > 0) {
                scrollspyItems[currentIndex - 1].classList.remove('active');
            }
        }
    }

    window.addEventListener('optimizedScroll', setActiveScrollspyItem);

    return 'scrollSpy';

}
